import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'replaceText'})
export class ReplaceText implements  PipeTransform {

  transform(value: any) {
    return value ? String(value).replace(/<[^>]+>/gm, ' ') : ''; // used regular expression
  }
}
